import type { ReactNode } from 'react';

export const symbol_open_jam: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M450-180H270q-12.75 0-21.37 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.37 8.5h420q12.75 0 21.38-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.38-8.5H510v-339l55 55q10 10 23 10t23-10q10-10 10-23t-10-23L501-620q-9-9-21-9t-21 9L349-510q-10 10-10 23t10 23q10 10 23 10t23-10l55-55v339Zm30-300ZM140-328q-24 0-42-18t-18-42v-392q0-24 18-42t42-18h680q24 0 42 18t18 42v392q0 24-18 42t-42 18H640q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h180v-392H140v392h180q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H140Z"
		/>
	</svg>
);
